export interface IAside {
  height: number;
  isNavigationActive: boolean;
  activeAnchor: string;
}

export interface IAsideHeightAction {
  height: number;
  type: 'IAsideHeight';
}

export interface INavigationToggleAction {
  isActive: boolean | undefined;
  type: 'INavigationToggle';
}

export interface INavigationAnchorChangedAction {
  activeAnchor: string;
  type: 'INavigationAnchorChanged';
}

export function setHeight(height: number): IAsideHeightAction {
  return {
    height,
    type: 'IAsideHeight',
  };
}

export function toggle(isActive?: boolean): INavigationToggleAction {
  return {
    isActive,
    type: 'INavigationToggle',
  };
}

export function changeNavigationAnchor(activeAnchor: string) {
  return {
    activeAnchor,
    type: 'INavigationAnchorChanged',
  };
}

const defaultState: IAside = {
  height: 0,
  isNavigationActive: false,
  activeAnchor: '#photos',
};

export function asideReducer(
  state: IAside,
  action: IAsideHeightAction | INavigationToggleAction | INavigationAnchorChangedAction,
): IAside {
  switch (action.type) {
    case 'IAsideHeight':
      return {
        ...state,
        height: action.height,
      };

    case 'INavigationToggle':
      return {
        ...state,
        isNavigationActive: typeof action.isActive !== 'undefined' ? action.isActive : !state.isNavigationActive,
      };

    case 'INavigationAnchorChanged':
      return {
        ...state,
        activeAnchor: action.activeAnchor,
      };

    default:
      return state || defaultState;
  }
}
